import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {VotingControlService} from '@modules/voting/voting-control.service';
import {VotingControllerComponent} from '@modules/voting/voting-controller/voting-controller.component';
import {CaptchaService} from '@core/services/captcha/captcha.service';
import {Subscription} from 'rxjs';
import {SectionItem} from '@modules/voting/models/section-item';
import {VotingSectionComponent} from '@modules/voting/voting-section/voting-section.component';
import {AnalyticsService} from '@utils/services/analytics/analytics.service';

@Component({
  selector: 'app-voting-navigation',
  templateUrl: './voting-navigation.component.html',
  styleUrls: ['./voting-navigation.component.scss']
})
export class VotingNavigationComponent implements OnInit, OnDestroy {
  @ViewChild('captchaContainer') captchaContainer: ElementRef;

  captchaLoadedSubscription: Subscription;

  constructor(
    private analyticsService: AnalyticsService,
    public votingController: VotingControllerComponent,
    public votingControl: VotingControlService,
    public captchaService: CaptchaService
  ) {}

  ngOnInit (): void {
    this.captchaLoadedSubscription = this.captchaService.onCaptchaLoaded.subscribe(loaded => {
      if (loaded) {
        this.captchaService.renderCaptcha(this.captchaContainer);
      }
    });
  }

  ngOnDestroy(): void {
    this.captchaLoadedSubscription?.unsubscribe();
  }

  public async submitVote() {
    if (!this.captchaService.captchaFulfilled) {
      return;
    }

    const item_ids = [];

    this.votingController.votingSections.forEach((section: VotingSectionComponent) => {
      section.selectedItems.forEach((item: SectionItem) => {
        item_ids.push(item.itemid);
      });
    });

    await this.votingControl.vote(item_ids);

    const searchParams = new URLSearchParams();
    searchParams.set('voteSubmission', 'true');
    this.analyticsService.sendPageView({queryParams: searchParams});
  }

  public reloadPage() {
    window.location?.reload();
    return false; // inhibit link resolution
  }
}
